/* eslint-disable no-new */
import Cookies from 'universal-cookie';

const cookies = new Cookies();
const cookieRemoveOptions = { path: '/', sameSite: 'Strict' };

export const getCookies = (value = '') => cookies.get(value);
export const removeCookies = async (value = '') => {
  cookies.remove(value, cookieRemoveOptions);
};

/** Cookie keys set on login / user session. Remove all of these on logout. */
export const USER_COOKIE_KEYS = [
  'Token',
  'refreshToken',
  'USERID',
  'USEREMAIL',
  'PROFILE',
  'USERNAME',
  'BUSINESSNAME',
  'USERROLE',
  'USERPERMISSION',
  'THEME',
];

/** Removes all user-related cookies. Call on logout. */
export const clearUserCookiesOnLogout = () => {
  USER_COOKIE_KEYS.forEach((key) => {
    cookies.remove(key, cookieRemoveOptions);
  });
  // Clear the "had active session" flag so the cookies-cleared popup
  // does not appear on the next fresh login.
  try {
    localStorage.removeItem('marq_had_session');
  } catch (_) {
    // localStorage may be unavailable in some sandboxed environments
  }
};

export const setCookies = (key = '', value = '') => {
  cookies.set(key, value, {
    path: '/',
    sameSite: 'Strict',
  });
};
